import React from 'react';
import { BackToTop } from '@/presentation/layouts/tools/back-to-top';
import { RightlyNotice } from '@/presentation/layouts/tools/rightly-notice';
import style from './index.module.scss';

export const Tools = () => <div className={style.toolsLayout}>
  <BackToTop />
  <RightlyNotice />
</div>;
